<div class="flex flex-col gap-2">
    <p-confirmpopup
        acceptLabel="Yes"
        key="removeValueDescriptionRowPopup"
        rejectLabel="No"
        [baseZIndex]="8000"
    ></p-confirmpopup>
    <div class="flex justify-between items-center">
        <label>Value Table</label>
        <p-button
            icon="pi pi-plus"
            [text]="true"
            pTooltip="Add new value description"
            tooltipPosition="bottom"
            [showDelay]="500"
            (click)="addRow()"
        ></p-button>
    </div>
    <div class="st-border">
        <p-table [value]="rows" dataKey="rowId">
            <ng-template #header>
                <tr>
                    <th class="w-36">Value</th>
                    <th>Description</th>
                    <th class="w-20">Active</th>
                    <th class="w-4"></th>
                </tr>
            </ng-template>
            <ng-template #body let-row>
                <tr>
                    <td>
                        <input
                            pInputText
                            class="w-48"
                            type="text"
                            inputmode="numeric"
                            [invalid]="showValidationMessage && isValueInvalid(row)"
                            [attr.aria-invalid]="showValidationMessage && isValueInvalid(row)"
                            [ngModel]="row.value"
                            [ngModelOptions]="{ standalone: true }"
                            (ngModelChange)="onValueChange(row, $event)"
                            (blur)="onRowFieldBlur()"
                        />
                    </td>
                    <td>
                        <input
                            pInputText
                            class="w-full"
                            type="text"
                            [ngModel]="getDescriptionText(row)"
                            [ngModelOptions]="{ standalone: true }"
                            (ngModelChange)="onDescriptionChange(row, $event)"
                            (blur)="onRowFieldBlur()"
                        />
                    </td>
                    <td class="w-16">
                        <p-toggleSwitch
                            [ngModel]="row.isActive"
                            [ngModelOptions]="{ standalone: true }"
                            (ngModelChange)="onIsActiveChange(row, $event)"
                        ></p-toggleSwitch>
                    </td>
                    <td class="w-4">
                        @if (row.isNew) {
                            <p-button
                                icon="pi pi-trash"
                                [text]="true"
                                severity="danger"
                                pTooltip="Remove unsaved row"
                                tooltipPosition="bottom"
                                [showDelay]="500"
                                (click)="confirmRemoveUnsavedRow(row, $event)"
                            ></p-button>
                        }
                    </td>
                </tr>
            </ng-template>
            <ng-template #emptymessage>
                <tr>
                    <td colspan="4" class="text-center">No items</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    @if (getVisibleValidationMessage(); as validationMessage) {
        <small class="text-red-500 text-xs">{{ validationMessage }}</small>
    }
</div>
